export default "//yastatic.net/s3/distribution/pythia/frontend/_/302a24ed1806c47b3782a80abd81c294.png";